import { StarIcon } from "lucide-react";

export function RatingInput({
  id,
  onChange,
  value,
  max = 10,
}: {
  id?: string;
  value: number;
  onChange: (v: number) => void;
  max?: number;
}) {
  return (
    <div className="flex items-center gap-2">
      {Array.from({ length: max })
        .fill(0)
        .map((_, i) => (
          <button
            className="aspect-square w-5"
            key={i}
            id={i === 0 ? id : undefined}
            type="button"
            onClick={() => {
              onChange(i + 1);
            }}
          >
            {value > i ? (
              <StarIcon className="fill-yellow-500 text-yellow-500" />
            ) : (
              <StarIcon className="text-muted-foreground" />
            )}
          </button>
        ))}
    </div>
  );
}
